import { render, staticRenderFns } from "./HomePricing.vue?vue&type=template&id=12d872d2&scoped=true&"
import script from "./HomePricing.vue?vue&type=script&lang=ts&"
export * from "./HomePricing.vue?vue&type=script&lang=ts&"
import style0 from "./HomePricing.vue?vue&type=style&index=0&id=12d872d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d872d2",
  null
  
)

export default component.exports